import { render } from "./MessagesMixin.vue?vue&type=template&id=4f88d6d6"
import script from "./MessagesMixin.vue?vue&type=script&lang=js"
export * from "./MessagesMixin.vue?vue&type=script&lang=js"

import exportComponent from "C:\\dev\\Lipa-Digital-Labs\\dev\\Potsmunter\\mpt-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__